module.exports = __webpack_public_path__ + "img/spiral-details14.7a1bd7fa.png";